import script from "./ProductAssociations.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductAssociations.vue?vue&type=script&setup=true&lang=ts"

import "./ProductAssociations.vue?vue&type=style&index=0&id=28683a60&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28683a60"]])

export default __exports__